import axios from "axios";
import {
  GET_SH_UNASSIGNED_TICKETS,
  GET_SH_CURRENT_HANDOVER,
  SET_SH_FETCHING_FLAG,
  GET_SH_OPERATION_LEADS,
  GET_SH_INCIDENT_DETAILS,
  SET_SH_SELECTED_SUPPORT_AREA,
  GET_SH_ONGOING_PM,
  GET_SH_INCIDENT_COUNTS,
  GET_SH_INCIDENT_COMMENTS_HISTORY,
  GET_SH_INCIDENT_WORKLOG_HISTORY,
  GET_SH_ADMIN_USERS_LIST,
  SET_SH_TOAST_VISIBLE,
  GET_SH_AGENT_ROLES_LIST,
  GET_SH_CDS_USER_DATA,
  GET_SH_BANNER_MESSSAGE,
  GET_SH_SERVICES,
  GET_SH_GLOBAL_CHAT_ACCEPTED_COUNT,
  GET_SH_GLOBAL_AVERAGE_HANDLING_TIME,
  GET_SH_GLOBAL_AVERAGE_WAITING_TIME,
  GET_SH_GLOBAL_CANCELLED_CHATS,
  GET_SH_GLOBAL_ACCEPTED_PENDING_CHATS,
  GET_SH_GLOBAL_AGENT_STATUS,
  GET_SH_GLOBAL_QUEUED_CHATS,
  GET_SH_GLOBAL_REJECTED_BUSY_CHATS,
  GET_SH_GLOBAL_REJECTED_TIMEOUT_CHATS,
  GET_SH_GLOBAL_TOTAL_COUNT,
  GET_SH_VOLUME_INCIDENT_COUNT,
  GET_SH_VOLUME_BAR_GRAPH_COUNT,
  GET_SH_INDIVIDUAL_COUNT,
  GET_SH_GLOBAL_AVAILABLE_ONGOING_CHATS,
  GET_SH_TEAM_TIMELINE,
  GET_SH_AGENT_DATA,
  GET_SH_EXPORT_AGENT_TIMELINE_DATA,
  GET_SH_INGKA_USER,
  GET_SH_GUSER_DATA,

} from "./types";
import { store } from "../store";
import { isWithinInterval, format, sub, add } from "date-fns";
import moment from "moment-timezone";  

let BASE_API_URL = "";
let BASE_URL_CSH = "";
if (
  process.env.REACT_APP_ENV === "DEV" &&
  process.env.REACT_APP_ITSD_ENV === "DEV"
) {
  BASE_API_URL = "https://dev.iobserve.backend.ingka.com";
} else if (
  process.env.REACT_APP_ENV === "DEV" &&
  process.env.REACT_APP_ITSD_ENV === "PPE"
) {
  BASE_API_URL = "https://stage.iobserve.backend.ingka.com";
} else if (
  process.env.REACT_APP_ENV === "PROD" &&
  process.env.REACT_APP_ITSD_ENV === "PROD"
) {
  BASE_API_URL = "https://prod.iobserve.backend.ingka.com";
}
const BASE_URL_PM =
  "https://ipm-backend.ingka.com";

  if (
    process.env.REACT_APP_ENV === "DEV" &&
    process.env.REACT_APP_ITSD_ENV === "PPE"
  ){

    BASE_URL_CSH = `https://stage.api.iobserve.ingka.com/api/v1/csh/itsd/post_notifications`;
  }else{
    BASE_URL_CSH = `${BASE_API_URL}/api/v1/csh/itsd/post_notifications`
  }

const BASE_URL_SH = `${BASE_API_URL}/aiops/iobserve/shifthandover`;
const BASE_URL_ITSD = `${BASE_API_URL}/aiops/iobserve/shifthandover`;

const supportAreaMapping = {
  "Support Team Supply": "ILO & FF", 
  "Support Team Customer":"Customer", 
  "Support Team CTI": "CTI", 
  "Support Team PBO": "PBO"
}


let BASE_API_URL_IPM_CONNECTOR =
  "https://dev.ipm.ingka.com/pm/connector";

  if (
    process.env.REACT_APP_ENV === "DEV" &&
    process.env.REACT_APP_ITSD_ENV === "DEV"
  ) {
    BASE_API_URL_IPM_CONNECTOR = "https://dev.ipm.ingka.com/pm/connector";
  } else if (
    process.env.REACT_APP_ENV === "DEV" &&
    process.env.REACT_APP_ITSD_ENV === "PPE"
  ) {
    BASE_API_URL_IPM_CONNECTOR = "https://dev.ipm.ingka.com/pm/connector";
  } else if (
    process.env.REACT_APP_ENV === "PROD" &&
    process.env.REACT_APP_ITSD_ENV === "PROD"
  ) {
    BASE_API_URL_IPM_CONNECTOR = "https://prod.ipm.ingka.com/pm/connector";
  }

export const getUnattendedHandoversList = async (selectedSupportArea) => {
  try {
    const token = store.getState().at.auth0token;
    const response = await axios.post(
      `${BASE_URL_SH}/getunassignedlist`,
      {
        Payload: {
          env: process.env.REACT_APP_ENV,
          supportgroup: selectedSupportArea,
        },
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const data = response.data?.response || [];
    return data;
  } catch (error) {
    console.error(error);
    return [];
  }
};
export const getCurrentHandoversList = async (selectedSupportArea) => {
  try {
    const token = store.getState().at.auth0token;
    const response = await axios.post(
      `${BASE_URL_SH}/currenthandoverlist`,
      {
        Payload: {
          supportgroup: selectedSupportArea,
          env: process.env.REACT_APP_ENV,
        },
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const data = response.data?.response || [];
    return data;
  } catch (error) {
    console.error(error);
    return [];
  }
};

export const getCurrentHandovers =
  (selectedSupportArea) => async (dispatch) => {
    try {
      dispatch({
        type: SET_SH_FETCHING_FLAG,
        payload: {
          apiType: "getCurrentHandovers",
          value: true,
        },
      });

      const token = store.getState().at.auth0token;
      const response = await axios.post(
        `${BASE_URL_SH}/currenthandoverlist`,
        {
          Payload: {
            supportgroup: selectedSupportArea,
            env: process.env.REACT_APP_ENV,
          },
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = response.data?.response || [];
      dispatch({
        type: GET_SH_CURRENT_HANDOVER,
        payload: data,
      });
    } catch (error) {
      console.error(error);
    } finally {
      dispatch({
        type: SET_SH_FETCHING_FLAG,
        payload: {
          apiType: "getCurrentHandovers",
          value: false,
        },
      });
    }
  };

export const getOperationLeadersDetails = (supportArea) => async (dispatch) => {
  try {
    dispatch({
      type: SET_SH_FETCHING_FLAG,
      payload: {
        apiType: "getOperationLeadersDetails",
        value: true,
      },
    });

    const token = store.getState().at.auth0token;
    const response = await axios.post(
      `${BASE_URL_SH}/olinfodetails`,
      {
        Payload: {
          supportgroup: supportArea.replace("Support Team", "").trim(),
        },
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const data = response.data?.response || {};

    dispatch({
      type: GET_SH_OPERATION_LEADS,
      payload: data,
    });
  } catch (error) {
    console.error(error);
  } finally {
    dispatch({
      type: SET_SH_FETCHING_FLAG,
      payload: {
        apiType: "getOperationLeadersDetails",
        value: false,
      },
    });
  }
};

export const addCommentOnIncident = async (payload) => {
  try {
    const token = store.getState().at.auth0token;
    const response = await axios.post(
      `${BASE_URL_SH}/addcomment`,
      {
        Payload: payload,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const newComments = response.data?.response?.[0];
    return newComments;
  } catch (error) {
    console.error(error);
    return false;
  }
};

export const getIncidentDetails = (incidentId, incidentType) => async (dispatch) => {
  try {
    dispatch({
      type: SET_SH_FETCHING_FLAG,
      payload: {
        apiType: "getIncidentDetails",
        value: true,
      },
    });

    const token = store.getState().at.auth0token;
    const response = await axios.post(
      `${BASE_URL_SH}/incidentdetails`,
      {
        Payload: {
          incident_number: incidentId,
          shifttype: incidentType === "unattended" ? "Unattended" : "Handover",
        },
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const details = response.data?.response;
    dispatch({
      type: GET_SH_INCIDENT_DETAILS,
      payload: details,
    });
  } catch (error) {
    console.error(error);
  } finally {
    dispatch({
      type: SET_SH_FETCHING_FLAG,
      payload: {
        apiType: "getIncidentDetails",
        value: false,
      },
    });
  }
};

export const setSelectedSupportArea = (supportArea) => (dispatch) => {
  dispatch({
    type: SET_SH_SELECTED_SUPPORT_AREA,
    payload: supportArea,
  });
};

export const getIncidentsCount = async (supportGroup, query) => {
  try {
    const token = store.getState().at.auth0token;
    const response = await axios.post(
      `${BASE_URL_SH}/incidentscount`,
      {
        Payload: {
          env: process.env.REACT_APP_ENV,
          supportgroup: supportGroup,
          query,
        },
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const count = response.data?.response;
    return count;
  } catch (error) {
    console.error(error);
    return {incidents_count:0,incident_details:[]};
  }
};

// export const getIncidentsCount =
//   (apiType, supportGroup, query) => async (dispatch) => {
//     try {
//       dispatch({
//         type: SET_SH_FETCHING_FLAG,
//         payload: {
//           apiType: apiType,
//           value: true,
//         },
//       });

//       const token = store.getState().at.auth0token;
//       const response = await axios.post(
//         `${BASE_URL_SH}/incidentscount`,
//         {
//           Payload: {
//             env: process.env.REACT_APP_ENV,
//             supportgroup: supportGroup,
//             query,
//           },
//         },
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );

//       const count = response.data?.response?.incidents_count || 0;
//       dispatch({
//         type: GET_SH_INCIDENT_COUNTS,
//         payload: { type: apiType, value: count },
//       });
//     } catch (error) {
//       console.error(error);
//     } finally {
//       dispatch({
//         type: SET_SH_FETCHING_FLAG,
//         payload: {
//           apiType: apiType,
//           value: false,
//         },
//       });
//     }
//   };

export const getOngoingPowerMaintenance = () => async (dispatch) => {
  try {
    dispatch({
      type: SET_SH_FETCHING_FLAG,
      payload: {
        apiType: "getOngoingPowerMaintenance",
        value: true,
      },
    });

    const token = store.getState().at.APIMtoken;
    const retailResponse = await axios.get(`${BASE_API_URL_IPM_CONNECTOR}/retail?status_filter=new&status_filter=inprogress&status_filter=assigned`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
        
    const supplyResponse = await axios.get(`${BASE_API_URL_IPM_CONNECTOR}/supply?status_filter=new&status_filter=inprogress&status_filter=assigned`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const retailData = retailResponse.data?.result || [];
    const supplyData = supplyResponse.data?.result || [];
    const data = [ ...retailData, ...supplyData];
    console.log(data, "Ongoing Power Maintenance Data");
    dispatch({
      type: GET_SH_ONGOING_PM,
      payload: data,
    });
  } catch (error) {
    console.error(error);
  } finally {
    dispatch({
      type: SET_SH_FETCHING_FLAG,
      payload: {
        apiType: "getOngoingPowerMaintenance",
        value: false,
      },
    });
  }
};

export const addIncidentToCSH = (inc) => async (dispatch) => {
  try {
    dispatch({
      type: SET_SH_FETCHING_FLAG,
      payload: {
        apiType: "addIncidentToCSH",
        value: true,
      },
    });
    const token = store.getState().at.auth0token;
    const auth0token = store.getState().at.auth0token;

    let status = inc.state.toLowerCase();
    status = ['new', 'in progress', 'on hold'].includes(status) ? 'inprogress' : status;
    let supportArea = inc.supportgroup.split("-")?.[0]?.trim();
    supportArea = supportAreaMapping[supportArea] || supportArea;
    const payload = {
      impact: inc.priority,
      message: inc.short_description,
      internal: {
        auditdoc_id: "",
        environment: "",
        modifiedOn: "",
        euuid: "",
        createdOn: "",
        parent_doc_id: "",
        action: "",
        reference_id: "",
        shifthandover: "true",
      },
      impactedMarkets: [],
      networkId: "",
      endDateTime: "",
      incidentNumber: inc.incident_number,
      extraInfo: "",
      status,
      modeOfCommunication: [],
      startDateTime: inc.start_date,
      typeOfEvent: "Critical Incident",
      greetingMessage: "",
      supportArea:[supportArea],
      lastupdateddate: inc.last_updated,
      assigned_group: inc.assigned_group,
      assigned_to: inc.assigned_to,
      location: inc.location,
      country: inc.country,
      comments: inc.comment,
    };

    const response = await axios.post(`${BASE_URL_CSH}`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        Auth0_token: auth0token,
      },
    });
    if (response?.data?.status === "success") {
      await axios.post(
        `${BASE_URL_SH}/cshupdatestatus`,
        {
          Payload: {
            incident_number: inc.incident_number,
            CSHaddedstatus: "True",
            shifttype: inc.incidentsource !== "unattended" ? "Handover": "Unattended",
          },
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch(getIncidentDetails(inc.incident_number,  inc?.incidentsource));
    }
  } catch (error) {
    console.error(error);
  } finally {
    dispatch({
      type: SET_SH_FETCHING_FLAG,
      payload: {
        apiType: "addIncidentToCSH",
        value: false,
      },
    });
  }
};

export const getCommentHistory = (payload) => async (dispatch) => {
  try {
    dispatch({
      type: SET_SH_FETCHING_FLAG,
      payload: {
        apiType: "getCommentHistory",
        value: true,
      },
    });

    const token = store.getState().at.auth0token;
    const response = await axios.post(
      `${BASE_URL_SH}/historyofcomments`,
      {
        Payload: payload,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const comments = response.data?.response?.commenthistory || [];
    dispatch({
      type: GET_SH_INCIDENT_COMMENTS_HISTORY,
      payload: comments,
    });
  } catch (error) {
    console.error(error);
  } finally {
    dispatch({
      type: SET_SH_FETCHING_FLAG,
      payload: {
        apiType: "getCommentHistory",
        value: false,
      },
    });
  }
};

export const getWorklogHistory = (payload) => async (dispatch) => {
  try {
    dispatch({
      type: SET_SH_FETCHING_FLAG,
      payload: {
        apiType: "getWorklogHistory",
        value: true,
      },
    });

    const token = store.getState().at.auth0token;
    const response = await axios.post(
      `${BASE_URL_SH}/historyofworknotes`,
      {
        Payload: payload,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const worknotes = response.data?.response?.worknotes || [];
    dispatch({
      type: GET_SH_INCIDENT_WORKLOG_HISTORY,
      payload: worknotes,
    });
  } catch (error) {
    console.error(error);
  } finally {
    dispatch({
      type: SET_SH_FETCHING_FLAG,
      payload: {
        apiType: "getWorklogHistory",
        value: false,
      },
    });
  }
};

export const addWorklog = async (payload) => {
  try {
    const token = store.getState().at.auth0token;
    const response = await axios.put(
      `${BASE_URL_SH}/updateworknotes`,
      {
        Payload: payload,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response ? true : false;
  } catch (error) {
    console.error(error);
    return false;
  }
};

// Shifhandover Admin Users List
export const getShiftHandoverAdminList = (platform, businessRole, usertype, user) => async (dispatch) => {

  try {
    dispatch({
      type: SET_SH_FETCHING_FLAG,
      payload: {
        apiType: "getShiftHandoverAdminList",
        value: true,
      },
    });
    const token = store.getState().at.auth0token;
    const payload = {
      platform: platform,
      businessRole: businessRole,
      usertype: usertype
    }
    const response = await axios.post(
      `${BASE_URL_SH}/fetchaccess?user=${user}`,
      { Payload: payload },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const adminList = response?.data?.response || [];
    if(usertype === "Admin"){
    dispatch({
      type: GET_SH_ADMIN_USERS_LIST,
      payload: adminList,
    });
  } else if(usertype === "Agent"){ 
     dispatch({
      type: GET_SH_AGENT_ROLES_LIST,
      payload: adminList,
    });
  } else if(usertype === "INGKA"){
     dispatch({
      type: GET_SH_INGKA_USER,
      payload: adminList || [],
    });
  } else if(usertype === "GUSER"){
     dispatch({
      type: GET_SH_GUSER_DATA,
      payload: adminList || [],
    })};
  } catch (error) {
    console.error(error);
    return [];
  } finally {
    dispatch({
      type: SET_SH_FETCHING_FLAG,
      payload: {
        apiType: "getShiftHandoverAdminList",
        value: false,
      },
    });
  }
};

export const addShiftHandoverAdmin = (payload, email) => async (dispatch) => {
  try {
    const token = store.getState().at.auth0token;
    dispatch({
      type: SET_SH_FETCHING_FLAG,
      payload: {
        apiType: "addShiftHandoverAdmin",
        value: true,
      },
    });
    await axios.post(
      `${BASE_URL_SH}/addagent?user=${email}`,
      { Payload: payload },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({
      type: SET_SH_TOAST_VISIBLE,
      payload: {
        visible: true,
        message: "User(s) added successfully!",
      },
    });
    dispatch(getShiftHandoverAdminList(payload?.platform,payload?.businessRole, payload?.usertype, email));
  } catch (error) {
    console.error(`Error with add :: ${error}`);
    dispatch({
      type: SET_SH_TOAST_VISIBLE,
      payload: {
        visible: true,
        message: "Failed to add user(s), please try again!",
      },
    });
  } finally {
    dispatch({
      type: "addShiftHandoverAdmin",
      payload: {
        apiType: "addShiftHandoverAdmin",
        value: false,
      },
    });
  }
};

export const addITSDAdmin = (payload, email) => async (dispatch) => {
  try {
    const token = store.getState().at.auth0token;
    dispatch({
      type: SET_SH_FETCHING_FLAG,
      payload: {
        apiType: "addShiftHandoverAdmin",
        value: true,
      },
    });
    await axios.post(
      `${BASE_URL_ITSD}/addagent?user=${email}`,
      { Payload: payload },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({
      type: SET_SH_TOAST_VISIBLE,
      payload: {
        visible: true,
        message: "User(s) added successfully!",
      },
    });
    dispatch(getShiftHandoverAdminList(payload?.platform,payload?.businessRole, payload?.usertype, email));
  } catch (error) {
    console.error(`Error with add :: ${error}`);
    dispatch({
      type: SET_SH_TOAST_VISIBLE,
      payload: {
        visible: true,
        message: "Failed to add user(s), please try again!",
      },
    });
  } finally {
    dispatch({
      type: "addShiftHandoverAdmin",
      payload: {
        apiType: "addShiftHandoverAdmin",
        value: false,
      },
    });
  }
};


export const deleteAdminUsers = (payload, email) => async (dispatch) => {
  try {
    const token = store.getState().at.auth0token;
    dispatch({
      type: SET_SH_FETCHING_FLAG,
      payload: {
        apiType: "deleteAdminUsers",
        value: true,
      },
    });
    await axios.post(
      `${BASE_URL_SH}/revokeaccess?user=${email}`,
      { Payload: payload },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({
      type: SET_SH_TOAST_VISIBLE,
      payload: {
        visible: true,
        message: "User(s) deleted successfully!",
      },
    });
    dispatch(getShiftHandoverAdminList(payload?.platform,payload?.businessRole, payload?.usertype, email));
  } catch (error) {
    console.error(`Error with deleteAdminUsers :: ${error}`);
    dispatch({
      type: SET_SH_TOAST_VISIBLE,
      payload: {
        visible: true,
        message: "Failed to delete user(s), please try again!",
      },
    });
  } finally {
    dispatch({
      type: SET_SH_FETCHING_FLAG,
      payload: {
        apiType: "deleteAdminUsers",
        value: false,
      },
    });
  }
};

export const updateOperationLeadList = async (payload) => {
  try {
    const token = store.getState().at.auth0token;
    const res = await axios.post(
      `${BASE_URL_SH}/modifyshift`,
      { Payload: payload },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return { error: false, res: res.data };
  } catch (error) {
    console.error(`Error modifying ol list ${error}`);
    return { error: true };
  }
};

export const getShiftHandoverAgentRolesList = () => async (dispatch) => {
  try {
    dispatch({
      type: SET_SH_FETCHING_FLAG,
      payload: {
        apiType: "getShiftHandoverAgentRolesList",
        value: true,
      },
    });
    const token = store.getState().at.auth0token;
    const response = await axios.get(`${BASE_URL_SH}/fetchagentroles`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const adminList = response?.data?.response || [];
    dispatch({
      type: GET_SH_AGENT_ROLES_LIST,
      payload: adminList,
    });
  } catch (error) {
    console.error(error);
    return [];
  } finally {
    dispatch({
      type: SET_SH_FETCHING_FLAG,
      payload: {
        apiType: "getShiftHandoverAgentRolesList",
        value: false,
      },
    });
  }
};

export const addShiftHandoverAgentRole = (payload) => async (dispatch) => {
  try {
    const token = store.getState().at.auth0token;
    dispatch({
      type: SET_SH_FETCHING_FLAG,
      payload: {
        apiType: "addShiftHandoverAgentRole",
        value: true,
      },
    });
    await axios.post(
      `${BASE_URL_SH}/addagentrole`,
      { Payload: payload },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({
      type: SET_SH_TOAST_VISIBLE,
      payload: {
        visible: true,
        message: "Role(s) added successfully!",
      },
    });
    dispatch(getShiftHandoverAgentRolesList());
  } catch (error) {
    console.error(`Error with add :: ${error}`);
    dispatch({
      type: SET_SH_TOAST_VISIBLE,
      payload: {
        visible: true,
        message: "Failed to add role(s), please try again!",
      },
    });
  } finally {
    dispatch({
      type: SET_SH_FETCHING_FLAG,
      payload: {
        apiType: "addShiftHandoverAgentRole",
        value: false,
      },
    });
  }
};

export const deleteAgentRole = (payload) => async (dispatch) => {
  try {
    const token = store.getState().at.auth0token;
    dispatch({
      type: SET_SH_FETCHING_FLAG,
      payload: {
        apiType: "deleteAgentRole",
        value: true,
      },
    });
    await axios.post(
      `${BASE_URL_SH}/removeagentrole`,
      { Payload: payload },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({
      type: SET_SH_TOAST_VISIBLE,
      payload: {
        visible: true,
        message: "Job title(s) deleted successfully!",
      },
    });
    dispatch(getShiftHandoverAgentRolesList());
  } catch (error) {
    console.error(`Error with deleteAgentRole :: ${error}`);
    dispatch({
      type: SET_SH_TOAST_VISIBLE,
      payload: {
        visible: true,
        message: "Failed to delete agent job title(s), please try again!",
      },
    });
  } finally {
    dispatch({
      type: SET_SH_FETCHING_FLAG,
      payload: {
        apiType: "deleteAgentRole",
        value: false,
      },
    });
  }
};

export const getCDSUserData = (email) => async (dispatch) => {
  try {
    dispatch({
      type: SET_SH_FETCHING_FLAG,
      payload: {
        apiType: "getCDSUserData",
        value: true,
      },
    });
    const auth0token = store.getState().at.auth0token;
    const { data } = await axios.get(
      `https://iobserve-backend-soyaaeguoa-ez.a.run.app/aiops/cds/user?userId=${email}`,
      {
        headers: {
          Authorization: `Bearer ${auth0token}`,
        },
      }
    );
    dispatch({
      type: GET_SH_CDS_USER_DATA,
      payload: data,
    });
  } catch (error) {
    console.error(`Error fetching cds data :: ${error}`);
  }finally{
    dispatch({
      type: SET_SH_FETCHING_FLAG,
      payload: {
        apiType: "getCDSUserData",
        value: false,
      },
    });
  }
};

export const updateIncidentState = async (payload) => {
  try {
    const token = store.getState().at.auth0token;
    const res = await axios.post(
      `${BASE_URL_SH}/historyofworknotes`,
      { Payload: payload },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return { error: false, res: res.data };
  } catch (error) {
    console.error(`Error updating status ${error}`);
    return { error: true };
  }
};

export const postBanner = payload => async(dispatch) => {
  try {
    const token = store.getState().at.auth0token;
    await axios.post(
      `${BASE_URL_SH}/usernotification`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({
      type: SET_SH_TOAST_VISIBLE,
      payload: {
        visible: true,
        message: "Banner posted successfully!",
      },
    });
    dispatch(getBanner(payload?.supportgroup))
  } catch (error) {
    console.error(error);
    dispatch({
      type: SET_SH_TOAST_VISIBLE,
      payload: {
        visible: true,
        message: "Failed to post banner",
      },
    });
  } 
};

export const getBanner = (supportArea) => async (dispatch) => {
  try {
    dispatch({
      type: SET_SH_FETCHING_FLAG,
      payload: {
        apiType: "getBanner",
        value: true,
      },
    });
    const token = store.getState().at.auth0token;
    let supportgroup = supportArea.replace("Support Team", "").trim()
    const { data } = await axios.get(
      `${BASE_URL_SH}/getusernotification?supportgroup=${supportgroup}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({
      type: GET_SH_BANNER_MESSSAGE,
      payload: data,
    });
  } catch (error) {
    console.error(error);

  } finally {
    dispatch({
      type: SET_SH_FETCHING_FLAG,
      payload: {
        apiType: "getBanner",
        value: false,
      },
    });
  }
};

export const getFinopsBaseUrl = () => {
  let nowItBaseURL = "https://dev.iobserve.backend.ingka.com";
  if (
    process.env.REACT_APP_ENV === "DEV" &&
    process.env.REACT_APP_ITSD_ENV === "DEV"
  ) {
    nowItBaseURL = "https://dev.iobserve.backend.ingka.com";
  } else if (
    process.env.REACT_APP_ENV === "DEV" &&
    process.env.REACT_APP_ITSD_ENV === "PPE"
  ) {
    nowItBaseURL = "https://stage.iobserve.backend.ingka.com";
  } else if (
    process.env.REACT_APP_ENV === "PROD" &&
    process.env.REACT_APP_ITSD_ENV === "PROD"
  ) {
    nowItBaseURL = "https://prod.iobserve.backend.ingka.com";
  }

  return nowItBaseURL;
};

export const getServersServices = (date) => async(dispatch) => {

  try {
    dispatch({
      type: SET_SH_FETCHING_FLAG,
      payload: {
        apiType: "getServersServices",
        value: true,
      },
    });

    const token = store.getState().at.auth0token;
    const payload = {
      Payload: {
        fromdate: date[0],
        todate: date[1],
        label: "shifthandover"
      }
    }

    let { data } = await axios.post(
      `${getFinopsBaseUrl()}/cloudbilling/taggedservices`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    let response = data?.Response.map(item=>{
      return {
        id: item?.service,
        value: item?.totalservicecost,
      }
    })

    dispatch({
      type: GET_SH_SERVICES,
      payload: response,
    });

  } catch (error) {
    console.error(error);
  }finally {
    dispatch({
      type: SET_SH_FETCHING_FLAG,
      payload: {
        apiType: "getServersServices",
        value: false,
      },
    });
  }
};

export const getGlobalAcceptedCount = () => async (dispatch) => {
  try {
    dispatch({
      type: SET_SH_FETCHING_FLAG,
      payload: {
        apiType: "getGlobalAcceptedCount",
        value: true,
      },
    });
    const token = store.getState().at.auth0token;
    const {data} = await axios.get(
      `${BASE_URL_SH}/chat/acceptedchat?platform=global`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({
      type: GET_SH_GLOBAL_CHAT_ACCEPTED_COUNT,
      payload: data?.response?.accepted_count || 0,
    });
  } catch (error) {
    console.error(error);
  } finally {
    dispatch({
      type: SET_SH_FETCHING_FLAG,
      payload: {
        apiType: "getGlobalAcceptedCount",
        value: false,
      },
    });
  }
};

export const getGlobalAveragehandlingTime = () => async (dispatch) => {
  try {
    dispatch({
      type: SET_SH_FETCHING_FLAG,
      payload: {
        apiType: "getGlobalAveragehandlingTime",
        value: true,
      },
    });
    const token = store.getState().at.auth0token;
    const {data} = await axios.get(
      `${BASE_URL_SH}/chat/averagehandlingtime?platform=global`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({
      type: GET_SH_GLOBAL_AVERAGE_HANDLING_TIME,
      payload: data?.response?.average_handling_time || 0,
    });
  } catch (error) {
    console.error(error);
  } finally {
    dispatch({
      type: SET_SH_FETCHING_FLAG,
      payload: {
        apiType: "getGlobalAveragehandlingTime",
        value: false,
      },
    });
  }
};

export const getGlobalAverageWaitingTime = () => async (dispatch) => {
  try {
    dispatch({
      type: SET_SH_FETCHING_FLAG,
      payload: {
        apiType: "getGlobalAverageWaitingTime",
        value: true,
      },
    });
    const token = store.getState().at.auth0token;
    const {data} = await axios.get(
      `${BASE_URL_SH}/chat/averagewaitingtime?platform=global`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({
      type: GET_SH_GLOBAL_AVERAGE_WAITING_TIME,
      payload: data?.response?.average_waiting_time || 0,
    });
  } catch (error) {
    console.error(error);
  }  finally {
    dispatch({
      type: SET_SH_FETCHING_FLAG,
      payload: {
        apiType: "getGlobalAverageWaitingTime",
        value: false,
      },
    });
  }
};

export const getGlobalPendingAcceptedChats = () => async (dispatch) => {
  try {
    const token = store.getState().at.auth0token;
    const {data} = await axios.get(
      `${BASE_URL_SH}/chat/pendingaccept?platform=global`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({
      type: GET_SH_GLOBAL_ACCEPTED_PENDING_CHATS,
      payload: data?.response?.pending_counts || 0,
    });
  } catch (error) {
    console.error(error);

  } finally {
    
    dispatch({
      type: SET_SH_FETCHING_FLAG,
      payload: {
        apiType: "getGlobalPendingAcceptedChats",
        value: false,
      },
    });
  }
};

export const getGlobalCancelledChats = () => async (dispatch) => {
  try {
    dispatch({
      type: SET_SH_FETCHING_FLAG,
      payload: {
        apiType: "getGlobalCancelledChats",
        value: true,
      },
    });
    const token = store.getState().at.auth0token;
    const { data } = await axios.get(
      `${BASE_URL_SH}/chat/cancelledchats?platform=global`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({
      type: GET_SH_GLOBAL_CANCELLED_CHATS,
      payload: data?.response?.cancelled_counts ? data.response.cancelled_counts: 0,
    });
  } catch (error) {
    console.error(error);
  } finally {
    dispatch({
      type: SET_SH_FETCHING_FLAG,
      payload: {
        apiType: "getGlobalCancelledChats",
        value: false,
      },
    });
  }
};

export const getGlobalQueuedChats = () => async (dispatch) => {
  try {
    dispatch({
      type: SET_SH_FETCHING_FLAG,
      payload: {
        apiType: "getGlobalQueuedChats",
        value: true,
      },
    });
    const token = store.getState().at.auth0token;
    const { data } = await axios.get(
      `${BASE_URL_SH}/chat/queuedchats`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({
      type: GET_SH_GLOBAL_QUEUED_CHATS,
      payload: data?.response?.queued_counts || 0,
    });
  } catch (error) {
    console.error(error);
  } finally {
    dispatch({
      type: SET_SH_FETCHING_FLAG,
      payload: {
        apiType: "getGlobalQueuedChats",
        value: false,
      },
    });
  }
};

export const getGlobalRejectedBusyChats = () => async (dispatch) => {
  try {
    dispatch({
      type: SET_SH_FETCHING_FLAG,
      payload: {
        apiType: "getGlobalRejectedBusyChats",
        value: true,
      },
    });
    const token = store.getState().at.auth0token;
    const { data } = await axios.get(
      `${BASE_URL_SH}/chat/rejectedbusy?platform=global`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({
      type: GET_SH_GLOBAL_REJECTED_BUSY_CHATS,
      payload: data?.response?.busy_count || 0,
    });
  } catch (error) {
    console.error(error);
  } finally {
    dispatch({
      type: SET_SH_FETCHING_FLAG,
      payload: {
        apiType: "getGlobalRejectedBusyChats",
        value: false,
      },
    });
  }
};

export const getGlobalRejectedTimeOutChats = () => async (dispatch) => {
  try {
    dispatch({
      type: SET_SH_FETCHING_FLAG,
      payload: {
        apiType: "getGlobalRejectedTimeOutChats",
        value: true,
      },
    });
    const token = store.getState().at.auth0token;
    const { data } = await axios.get(
      `${BASE_URL_SH}/chat/rejectedtimeout?platform=global`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({
      type: GET_SH_GLOBAL_REJECTED_TIMEOUT_CHATS,
      payload: data?.response?.timeout_count || 0,
    });
  } catch (error) {
    console.error(error);

  } finally {
    dispatch({
      type: SET_SH_FETCHING_FLAG,
      payload: {
        apiType: "getGlobalRejectedTimeOutChats",
        value: false,
      },
    });
  }
};

export const getGlobalTotalCount = () => async (dispatch) => {
  try {
    dispatch({
      type: SET_SH_FETCHING_FLAG,
      payload: {
        apiType: "getGlobalTotalCount",
        value: true,
      },
    });
    const token = store.getState().at.auth0token;
    const { data } = await axios.get(
      `${BASE_URL_SH}/chat/total`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({
      type: GET_SH_GLOBAL_TOTAL_COUNT,
      payload: data?.response?.totalchats_count || 0,
    });
  } catch (error) {
    console.error(error);
  } finally {
    dispatch({
      type: SET_SH_FETCHING_FLAG,
      payload: {
        apiType: "getGlobalTotalCount",
        value: false,
      },
    });
  }
};

export const getVolumeLabelData = () => async (dispatch) => {
  try {
    dispatch({
      type: SET_SH_FETCHING_FLAG,
      payload: {
        apiType: "getVolumeLabelData",
        value: true,
      },
    });
    const queries = ["major_incident_state=Accepted", "major_incident_state=Proposed", "priorityIN1", "priorityIN2"];
    const token = store.getState().at.auth0token;
    const requests = queries.map(query => axios.post(
      `${BASE_URL_SH}/volume/incidentcounts`,
      {
        Payload: {
          env: process.env.REACT_APP_ENV,
          query,
        },
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    ));

    const data = await Promise.all(requests);
    const response = data.map(item => item.data?.response?.incidents_count || 0);
    dispatch({
      type: GET_SH_VOLUME_INCIDENT_COUNT,
      payload: {
        volumeIncidentCount: response[0],
        majorIncidentCandidate: response[1],
        criticalIncident: response[2],
        urgentIncident: response[3]
      },
    });
  } catch (error) {
  } finally {
    dispatch({
      type: SET_SH_FETCHING_FLAG,
      payload: {
        apiType: "getVolumeLabelData",
        value: false,
      },
    });
  }
}

export const getVolumeLabelBarGraphData = () => async (dispatch) => {
  try {
    dispatch({
      type: SET_SH_FETCHING_FLAG,
      payload: {
        apiType: "getVolumeLabelBarGraphData",
        value: true,
      },
    });
    const queries = ["assignedritm","assignedincident"];
    const token = store.getState().at.auth0token;
    const requests = queries.map(query => axios.get(
      `${BASE_URL_SH}/volume/${query}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    ));

    const data = await Promise.all(requests);
    const response = data.map(item => item.data?.response || 0);
    dispatch({
      type: GET_SH_VOLUME_BAR_GRAPH_COUNT,
      payload: {
        assignedRITMS: response[0]?.ritms_count || 0,
        assignedIncident: response[1]?.incidents_count || 0,
      },
    });
  } catch (error) {
  } finally {
    dispatch({
      type: SET_SH_FETCHING_FLAG,
      payload: {
        apiType: "getVolumeLabelBarGraphData",
        value: false,
      },
    });
  }
}

// export const getIndividualData = () => async (dispatch) => {
//   try {
//     dispatch({
//       type: SET_SH_FETCHING_FLAG,
//       payload: {
//         apiType: "getIndividualData",
//         value: true,
//       },
//     });
//     const queries = ["agentstatus", "acceptedchat", "averagehandlingtime", "averagewaitingtime", "rejectedbusy", "rejectedtimeout"];
//     const token = store.getState().at.auth0token;
//     const requests = queries.map(query => axios.get(
//       `${BASE_URL_SH}/chat/${query}?platform=individual`,
//       {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       }
//     ));

//     const data = await Promise.all(requests);
//     const response = data.map(item => item.data?.response?.flatMap((item, index) => {
//       return item.agentdetails = item.agentdetails.map((agent, index) => {
//           return {
//                team: item.team,
//                ...agent,
//            }
//      })}));
//      const finalData = response[0].map((item, index) => {
//       return {
//           ...item,
//           accepted_count: response[1].find(b => b.agent === item.agent)?.accepted_count || 0,
//           average_handling_time: response[2].find(c => c.agent === item.agent)?.average_handling_time || "00:00:00",
//           average_waiting_time: response[3].find(d => d.agent === item.agent)?.average_waiting_time || "00:00:00",
//           busy_count: response[4].find(d => d.agent === item.agent)?.busy_count || 0,
//           timeout_count: response[5].find(d => d.agent === item.agent)?.timeout_count || 0,
//       }
//   })
//     dispatch({
//       type: GET_SH_INDIVIDUAL_COUNT,
//       payload: finalData,
//     });
//   } catch (error) {
//   } finally {
//     dispatch({
//       type: SET_SH_FETCHING_FLAG,
//       payload: {
//         apiType: "getIndividualData",
//         value: false,
//       },
//     });
//   }
// }

export const getGlobalAgentStatus = () => async (dispatch) => {
  try {
    dispatch({
      type: SET_SH_FETCHING_FLAG,
      payload: {
        apiType: "getGlobalAgentStatus",
        value: true,
      },
    });
    const token = store.getState().at.auth0token;
    const { data } = await axios.get(
      `${BASE_URL_SH}/chat/agentstatus?platform=global`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({
      type: GET_SH_GLOBAL_AGENT_STATUS,
      payload: {
        availableagents: data?.response?.availableagents || 0,
        not_ready: data?.response?.not_ready || 0,
      }
    });
  } catch (error) {
    console.error(error);

  } finally {
    dispatch({
      type: SET_SH_FETCHING_FLAG,
      payload: {
        apiType: "getGlobalAgentStatus",
        value: false,
      },
    });
  }
};

export const getGlobalOngoingAvailableChats = () => async (dispatch) => {
  try {
    dispatch({
      type: SET_SH_FETCHING_FLAG,
      payload: {
        apiType: "getGlobalOngoingAvailableChats",
        value: true,
      },
    });
    const token = store.getState().at.auth0token;
    const { data } = await axios.get(
      `${BASE_URL_SH}/chat/agentchats`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({
      type: GET_SH_GLOBAL_AVAILABLE_ONGOING_CHATS,
      payload: data?.response?.ongoingagent_chat || 0,
    });
  } catch (error) {
    console.error(error);

  } finally {
    dispatch({
      type: SET_SH_FETCHING_FLAG,
      payload: {
        apiType: "getGlobalOngoingAvailableChats",
        value: false,
      },
    });
  }
};

export const getAgentTimeLine = (team) => async (dispatch) => {
  try {
    dispatch({
      type: SET_SH_FETCHING_FLAG,
      payload: {
        apiType: "getAgentTimeLine",
        value: true,
      },
    });
    const token = store.getState().at.auth0token;
    const { data } = await axios.get(
      `${BASE_URL_SH}/chat/agenttimeline`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const response = data?.response?.filter(item => item.businessRole === team).map(item => {
      return {
        // ...item.data?.response,
        chatCount: item.chat_count,
        agentname: item.agentname,
        timeline: item.timeline?.map(t => {
            const cetFromTime = moment.tz(t.fromtime, "Europe/Berlin");
            const cetToTime = moment.tz(t.totime, "Europe/Berlin");
          const timezone = "UTC +05:30";
          const offset = timezone.split(" ")[1];
          const offsetHours = parseInt(offset.split(":")[0]);
          const offsetMinutes = parseInt(offset.split(":")[1]);
          if (offset[0] === "-") {
            cetFromTime.add(-offsetHours, 'hours').add(-offsetMinutes, 'minutes');
            cetToTime.add(-offsetHours, 'hours').add(-offsetMinutes, 'minutes');
          } else {
            cetFromTime.add(offsetHours, 'hours').add(offsetMinutes, 'minutes');
            cetToTime.add(offsetHours, 'hours').add(offsetMinutes, 'minutes');;
          }
          return {
            ...t,
            fromtime: cetFromTime.format("YYYY-MM-DD HH:mm:ss"),
            totime: cetToTime.format("YYYY-MM-DD HH:mm:ss"),
            chat_count: t?.chat_count,
          }
        })
          .filter(t => {
            const todayStart = new Date();
            todayStart.setHours(0, 0, 0, 0);
            const todayEnd = new Date();
            todayEnd.setHours(23, 59, 59, 999);
            const fromTimeInterval = isWithinInterval(new Date(t?.fromtime), { start: todayStart, end: todayEnd });
            const toTimeInterval = isWithinInterval(new Date(t?.totime), { start: todayStart, end: todayEnd });
            return fromTimeInterval || toTimeInterval;
          })
      }
    });
    dispatch({
      type: GET_SH_TEAM_TIMELINE,
      payload: response,
    });
  } catch (error) {
    console.error(error);

  } finally {
    dispatch({
      type: SET_SH_FETCHING_FLAG,
      payload: {
        apiType: "getAgentTimeLine",
        value: false,
      },
    });
  }
};

export const getAgentData = (agents) => async (dispatch) => {
  try {
     dispatch({
      type: SET_SH_FETCHING_FLAG,
      payload: {
        apiType: "getAgentData",
        value: true,
      },
    });
    const token = store.getState().at.auth0token;
    let requests = agents.map(async (agent) => await axios.get(
      `${BASE_URL_SH}/chat/individual-report?agentname=${agent}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    );
    let agentExportData = await Promise.all(requests);
    agentExportData = agentExportData.map(item => item?.data || []);
    dispatch({
      type: GET_SH_AGENT_DATA,
      payload: agentExportData,
    });
     dispatch({
      type: SET_SH_FETCHING_FLAG,
      payload: {
        apiType: "getAgentData",
        value: false,
      },
    });
  } catch (error) {
    console.error(error);
  }
};

export const getExportAgentLineData = (agent) => async (dispatch) => {
  try {
    const token = store.getState().at.auth0token;
    let { data } = await axios.get(
        `${BASE_URL_SH}/chat/timeline-report?agentname=${agent}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
    dispatch({
      type: GET_SH_EXPORT_AGENT_TIMELINE_DATA,
      payload: data?.response || [],
    });
  } catch (error) {
    console.error(error);

  }
};

export const getIndividualData = () => async (dispatch) => {
  try {
     dispatch({
      type: SET_SH_FETCHING_FLAG,
      payload: {
        apiType: "getIndividualData",
        value: true,
      },
    });
    const token = store.getState().at.auth0token;
    const { data } = await axios.get(
      `${BASE_URL_SH}/chat/summary?platform=individual`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  dispatch({
      type: GET_SH_INDIVIDUAL_COUNT,
      payload: data?.response || [],
    });
  } catch (error) {
    console.error(error);

  } finally {
    dispatch({
      type: SET_SH_FETCHING_FLAG,
      payload: {
        apiType: "getIndividualData",
        value: false,
      },
    });
  }
};

export const getIngkaUsers = (email) => async (dispatch) => {
  try {
    const token = store.getState().at.auth0token;

    dispatch({
      type: SET_SH_FETCHING_FLAG,
      payload: {
        apiType: "getIngkaUsers",
        value: true,
      },
    });
   const response = await axios.get(`${BASE_URL_SH}/INGKA?user=${email}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    dispatch({
      type: GET_SH_INGKA_USER,
      payload: response?.data?.response || [],
    });
 
  } catch (error) {
    console.error(`Error with Ingka Users :: ${error}`);
  } finally {
    dispatch({
      type: SET_SH_FETCHING_FLAG,
      payload: {
        apiType: "getIngkaUsers",
        value: false,
      },
    });
  }
};
export const getGUsers = (email) => async (dispatch) => {
  try {
    const token = store.getState().at.auth0token;

    dispatch({
      type: SET_SH_FETCHING_FLAG,
      payload: {
        apiType: "getGUsers",
        value: true,
      },
    });
   const response = await axios.get(`${BASE_URL_SH}/GUSER?user=${email}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    dispatch({
      type: GET_SH_GUSER_DATA,
      payload: response?.data?.response || [],
    });
 
  } catch (error) {
    console.error(`Error with Ingka Users :: ${error}`);
  } finally {
    dispatch({
      type: SET_SH_FETCHING_FLAG,
      payload: {
        apiType: "getGUsers",
        value: false,
      },
    });
  }
};

export const deleteBusinessRole = (payload, email, user) => async (dispatch) => {
  try {
    const token = store.getState().at.auth0token;
    dispatch({
      type: SET_SH_FETCHING_FLAG,
      payload: {
        apiType: "deleteBusinessRole",
        value: true,
      },
    });
    await axios.delete(
      `${BASE_URL_SH}/delete_agents?user=${email}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: payload 
      }
    );
    dispatch({
      type: SET_SH_TOAST_VISIBLE,
      payload: {
        visible: true,
        message: "User(s) deleted successfully!",
      },
    });
    const api = user === "ingka" ? getIngkaUsers : getGUsers;
    dispatch(api(email));
  } catch (error) {
    console.error(`Error with deleteAdminUsers :: ${error}`);
    dispatch({
      type: SET_SH_TOAST_VISIBLE,
      payload: {
        visible: true,
        message: "Failed to delete user(s), please try again!",
      },
    });
  } finally {
    dispatch({
      type: SET_SH_FETCHING_FLAG,
      payload: {
        apiType: "deleteBusinessRole",
        value: false,
      },
    });
  }
};

export const addShiftHandoverAgent = (payload, email) => async (dispatch) => {
  try {
    const token = store.getState().at.auth0token;
    dispatch({
      type: SET_SH_FETCHING_FLAG,
      payload: {
        apiType: "addShiftHandoverAgent",
        value: true,
      },
    });
    await axios.post(
      `${BASE_URL_SH}/addagent?user=${email}`,
      { Payload: payload },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({
      type: SET_SH_TOAST_VISIBLE,
      payload: {
        visible: true,
        message: "User(s) added successfully!",
      },
    });
    const api = payload?.businessRole === "ingka" ? getIngkaUsers : getGUsers;
    dispatch(api(email));
  } catch (error) {
    console.error(`Error with add :: ${error}`);
    dispatch({
      type: SET_SH_TOAST_VISIBLE,
      payload: {
        visible: true,
        message: "Failed to add user(s), please try again!",
      },
    });
  } finally {
    dispatch({
      type: "addShiftHandoverAgent",
      payload: {
        apiType: "addShiftHandoverAgent",
        value: false,
      },
    });
  }
};